module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhand13-b6d61481a8d2407debedeb032b301238.jpg";